import { LocalStorageCompatible } from './local-storage-compatible';
import { isLocalStorageV13, LocalStorageV13 } from './local-storage-v13';
import { upgrade as upgradeFromPrevious } from './local-storage-v13.upgrade';
import { LocalStorageV14 } from './local-storage-v14';

/*
 * NOTE: Create new migration files only when you need to remove or edit existing field. Do not create new migration file for adding new field.
 */
export async function upgrade(raw: LocalStorageCompatible): Promise<LocalStorageV14> {
  const input: LocalStorageV13 = isLocalStorageV13(raw) ? raw : await upgradeFromPrevious(raw);
  const { data } = input;

  const { previewTheme, ...updatedData } = data;

  return {
    version: 14,
    data: updatedData,
  };
}
